// extracted by mini-css-extract-plugin
module.exports = {"title":"title__3grLa","image":"image__1tdTH","content":"content__3n77t","contacts":"contacts__2qlvs","contact":"contact__1v8fC","map":"map__2-d7G","margin":"margin__3hFL3"};